// extracted by mini-css-extract-plugin
export default {"wrapper":"HarmonyWithIqos_wrapper__oEMoY","important":"HarmonyWithIqos_important__tqstf","articleWrapper":"HarmonyWithIqos_articleWrapper__1PasS"};